const primaryMain = '#673ab7';
const primaryLight = '#8561c5';
const primaryDark = '#482880';
const secondaryMain = '#007bff';
const secondaryLight = '#69a9ff';
const secondaryDark = '#0050cb';
const borderColor = '#E5E8F7';
const borderColorLight = 'rgba(87,109,154,1)';
const error = 'rgb(255 0 0)';
const white = '#ffffff';
const black = '#000000';
const greyLight = '#f3f3f3';
const grey = '#dadada';
const greyDark = 'rgb(102, 102, 102)';
const brightGrey = '#ebf1f6';
const green = '#4ca514';
const greenLight = '#a3cc06';
const red = '#df3831';
const primaryText = '#ffffff';
const secondaryText = '#000000';
const disabledText = 'rgba(0, 0, 0, 0.38)';
const titleColor = '#acd3e3';
const bgColor = '#e8e8e8';
const bgColorLight = '#017bad';
const inputBg = white;
const bgPaper = '#0f316c';
const bgItem = '#082450';
const bgMainBody = '#eeeeee';
const bgPlayer = '#0b1d49';
const borderBottom = '2px solid #91bfec';
const playerControllersColor = white;
export { primaryMain, primaryLight, primaryDark, secondaryMain, secondaryLight, secondaryDark, primaryText, secondaryText, disabledText, titleColor, error, borderColor, borderColorLight, white, black, grey, greyLight, greyDark, brightGrey, green, greenLight, red, bgColor, bgColorLight, inputBg, bgPaper, bgItem, bgMainBody, bgPlayer, borderBottom, playerControllersColor, };
//# sourceMappingURL=colors.js.map